<template>
  <div v-if="hasPentaGates(chart)">
    <dynamic-zone-renderer v-for="gate in data"
                           :key="gate.key"
                           :title="gate.title"
                           :components="gate.components"
                           :add-paddings="false"
                           is-toggleable
                           @titleMouseover="highlightElement({
                                  type: types.gate,
                                  id: +gate.key,
                                  includePlanets: true,
                           })"
                           @titleMouseleave="clearAllHighlights"
    />
  </div>
  <div v-else>
    <dynamic-zone-renderer
                           :components="noContent ? noContent.components : []"
                           :add-paddings="false"
    />
  </div>
</template>

<script>

import WorkSuccessMixin from "@/mixins/WorkSuccessMixin";
import DynamicZoneRenderer from "@/components/renderer/DynamicZoneRenderer.vue";
import AnalysisQueryMixin from "@/mixins/AnalysisQueryMixin";
import HighlightingMixin from "@/mixins/HighlightingMixin";

export default {
  components: {DynamicZoneRenderer},
  mixins: [WorkSuccessMixin, AnalysisQueryMixin, HighlightingMixin],
  props: {
    chart: Object
  },

  data(){
    return {
      data: [],
      noContent: null,
    }
  },

  mounted() {
    if (this.hasPentaGates(this.chart)) {
      this.getPentaGates(this.chart)
    } else {
      this.getContent('noContent', '/analysis/introductions/introduction.no-penta-activations');
    }
  },
}
</script>